export default "__VITE_ASSET__CkA3BpaI__"